import React, { useLayoutEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import messages from './messages';
import { EditableReturnItemsTable } from './table/editable';
import { ReadOnlyReturnItemsTable } from './table/read-only';
import { useOnElementWidthChange } from '../../../../../hooks/use-on-element-width-change';
import { OrderDetailsSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';

import style from './items.module.less';

export const Items = ({ isEditable, returnFulfillmentId }) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useLayoutEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  }, []);

  useOnElementWidthChange(containerRef, setContainerWidth);

  return (
    <div ref={containerRef}>
      <ExpanderSection
        ariaLabelMessageDescriptor={messages.sectionAriaLabel}
        contentClassName={style['items-section-content']}
        headerContent={<SectionTitle messageDescriptor={messages.returnItems} />}
        sectionContent={
          isEditable ? (
            <EditableReturnItemsTable containerWidth={containerWidth} />
          ) : (
            <ReadOnlyReturnItemsTable containerWidth={containerWidth} returnFulfillmentId={returnFulfillmentId} />
          )
        }
        sectionId={OrderDetailsSectionId.ShipmentItems}
      />
    </div>
  );
};

Items.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  returnFulfillmentId: PropTypes.string.isRequired,
};
